import React from 'react';
import PropTypes from 'prop-types';
import {
	CardForm,
	Cards,
    Charges,
} from './';
import {
    showAddCard,
    hideAddCard,
    getCustomer
} from 'actions';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Link} from 'react-router';

class Account extends React.Component {
  constructor(props) {
      super(props);
      this.displayName = 'Account';
      this.state = {};
  }
  componentWillMount() {
      this.props.dispatch(getCustomer());
  }
  render() {
    return (
	 		<div>
	      <div className="account-container">
	      	<div className='row'>
	          <div className="col-xs-12 mb-lg">
	            <h2>Your Account</h2>
	            <p>You can manage your Payment method and see recent charges made to your account here.</p>
	          </div>
		    		<div className="col-xs-12">
	            <div className="panel panel-primary">
		            <div className="panel-heading">
	                <h3 className="panel-title">Recent Charges</h3>
		            </div>
		            <div className="panel-body">
	                <Charges limit={10} />
		            </div>
		            <div className="panel-footer clearfix">
	                <Link className="pull-right" to={"account/billing/charges"}>See all charges.</Link>
		            </div>
			        </div>
		        </div>
	    		</div>
	    		<div className='row'>
		    		<div className="col-md-6 col-lg-4">
		          <div className="panel panel-default">
		            <div className="panel-heading">
		              <h3 className="panel-title">Payment Methods</h3>
		            </div>
		            <div className="panel-body">
		              <h4>Cards</h4>
		              <Cards />
		            </div>
		            <div className="panel-footer clearfix">
		              <div className="row">
		                <div className="col-xs-6 col-xs-offset-6 col-md-4 col-md-offset-8">
		                  <div onClick={()=>{
		                    this.props.dispatch(showAddCard());
		                    }} className="btn btn-primary btn-block"><i className="fa fa-plus"></i> Add Card
		                  </div>
		                </div>
		              </div>
		            </div>
		          </div>
	          </div>
	    		</div>
	      </div>
	    </div>
    );
  }
}

export default connect()(Account);



// WEBPACK FOOTER //
// ./src/browser/components/account/account.js